import React, { useState, useCallback, useEffect } from "react";
import { Container, Label, ContentFlex, LabelContent } from "./styles";
import { Dropdown } from "semantic-ui-react";
import { producaov2 as api } from "../../../services/apis";
import { RenderIf } from "../../RenderIf";

function CursoSearchInputMultiple({
  handleChange,
  initiateValue,
  remove,
  selectedCursos,
  setSelectedCursos,
  hideLabel = false,
  ...props
}) {
  const [courseOptions, setCourseOptions] = useState([]);
  const [courseSearch, setCourseSearch] = useState("");

  const handleAlunoSearchChange = useCallback(e => {
    const search = e.target.value;
    setCourseSearch(search);

    const cleanSearch = search.toLowerCase().trim();

    api.get("/admin/course-trails").then(res => {
      console.log(res.data.length > 0);
      if (res.data.length > 0) {
        const options = res.data
          .filter(
            elem =>
              elem.id.toString().includes(cleanSearch) ||
              elem.curso.toLowerCase().includes(cleanSearch)
          )
          .map(c => ({
            key: c.id,
            text: `(${c.curso})[ID: ${c.id}]`,
            value: c.id,
          }));
        setCourseOptions(options);
      } else {
        setCourseOptions([]);
      }
    });
  }, []);

  useEffect(() => {
    handleAlunoSearchChange({ target: { value: "" } }); // Clear search initially
  }, []);

  useEffect(() => {
    if (initiateValue) {
      setSelectedCursos(initiateValue);
    }
  }, [initiateValue]);

  return (
    <Container>
      <div>
        <RenderIf isTrue={!hideLabel}>
          <Label>Selecione os Cursos que estarão na Trilha</Label>
          {selectedCursos && (
            <ContentFlex>
              {selectedCursos.map((elem, index) => {
                return (
                  <LabelContent
                    key={index}
                    title="Remover"
                    onClick={() =>
                      setSelectedCursos(prev =>
                        prev.filter(item => item.id !== elem.id)
                      )
                    }
                  >
                    <p>{`${elem.curso} X`}</p>
                  </LabelContent>
                );
              })}
            </ContentFlex>
          )}
        </RenderIf>
        <Dropdown
          placeholder="Busque pelo ID ou Nome do Curso"
          fluid
          multiple
          search
          selection
          options={courseOptions}
          onChange={handleChange}
          // searchQuery={courseSearch}
          onSearchChange={handleAlunoSearchChange}
          value={[0]}
        />
      </div>
    </Container>
  );
}

export default CursoSearchInputMultiple;
